/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead } from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead';
import {
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadFromJSON,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadFromJSONTyped,
    FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadToJSON,
} from './FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead';

/**
 * 
 * @export
 * @interface FindAllScreenerLeadWaitlistResponse
 */
export interface FindAllScreenerLeadWaitlistResponse {
    /**
     * 
     * @type {Array<FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead>}
     * @memberof FindAllScreenerLeadWaitlistResponse
     */
    data: Array<FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLead>;
    /**
     * 
     * @type {number}
     * @memberof FindAllScreenerLeadWaitlistResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof FindAllScreenerLeadWaitlistResponse
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof FindAllScreenerLeadWaitlistResponse
     */
    limit: number;
    /**
     * 
     * @type {boolean}
     * @memberof FindAllScreenerLeadWaitlistResponse
     */
    has_next: boolean;
}

/**
 * Check if a given object implements the FindAllScreenerLeadWaitlistResponse interface.
 */
export function instanceOfFindAllScreenerLeadWaitlistResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "limit" in value;
    isInstance = isInstance && "has_next" in value;

    return isInstance;
}

export function FindAllScreenerLeadWaitlistResponseFromJSON(json: any): FindAllScreenerLeadWaitlistResponse {
    return FindAllScreenerLeadWaitlistResponseFromJSONTyped(json, false);
}

export function FindAllScreenerLeadWaitlistResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllScreenerLeadWaitlistResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'limit': json['limit'],
        'has_next': json['has_next'],
    };
}

export function FindAllScreenerLeadWaitlistResponseToJSON(value?: FindAllScreenerLeadWaitlistResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ((value.data as Array<any>).map(FindAllScreenerTags200ResponseDataInnerScreenerLeadTagsInnerLeadToJSON)),
        'total': value.total,
        'page': value.page,
        'limit': value.limit,
        'has_next': value.has_next,
    };
}

